export default __webpack_public_path__ + "pgnv-assets/687666da8c0ee520d13b49c6baaf9f1b.png";